// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__vyRDO","title":"BackImages_title__3IJqM","images":"BackImages_images__2Uyoy"};